<!-- 利用開始日UI -->
<template>
  <div>
    <!-- チケット販売日カレンダーUI -->
    <TheCalendar
      :propMasterBook="masterBook"
      :propStartDateOfUse="startDateOfUse"
      :propOnSelectedDate="onSelectedDate"
    />
    <!-- チケット販売日カレンダーUI -->

    <!-- 利用開始日に関する注意文 -->
    <MbPurchaseStartedatCaution
      v-if="
        masterBook.content.description_json &&
        masterBook.content.description_json.MbPurchaseStartedatCaution
      "
      :note="masterBook.content.description_json.MbPurchaseStartedatCaution"
    />
  </div>
</template>

<script>
export default {
  name: "TheBbStartDateSelect",
  props: {
    onSelectedDate: {
      type: Function,
      required: true,
    },
    startDateOfUse: {
      type: String,
      required: true,
    },
    masterBook: {
      type: Object,
      required: true,
    },
  },
};
</script>
